'use client'

import React from 'react'

import { chakra } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import { fieldLabelStyles } from '../shared/fieldLabelStyles'

export type FieldLabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  colorScheme?: ColorScheme
}

export const FieldLabel = ({
  colorScheme = 'dark',
  children,
  ...props
}: FieldLabelProps) => (
  <chakra.label {...fieldLabelStyles(colorScheme)} {...props}>
    {children}
  </chakra.label>
)
